/**
 * [Modules] Reusable methods shared across the site. Typically, methods defined here _should_ be used across several pages.
 * As opposed to utilities, these methods are ran on document ready if its query is available.
 */

// Modules
import {callbackOnElements} from '@borngroup/born-utilities';
import coreModules from '*/modules';

coreModules.nameConverter = {
    default: '[data-name-converter-url]',
    init: function(query) {
        return import(/* webpackChunkName: "module-name-converter" */ '../modules/module.name-converter').then(NameConverter => {
            callbackOnElements(query || this.default, (el) => new NameConverter.default(el));
        });
    }
}

coreModules.loqateAddressCapture = {
    default: '[data-loqateaddress-capture]',
    init: function(query) {
        if (window.SFRA.SitePreferences.addressAutocompleteEnabled && window.SFRA.SitePreferences.enableLoqateAddressCapture) {
            return import(/* webpackChunkName: "module-loqateAddress-capture" */ '../modules/module.loqateAddress-capture').then(loqateAddressCapture => {
                return loqateAddressCapture.init({elements: query || this.default});
            });
        }
    }
}

export default coreModules;
